module.exports = __webpack_public_path__ + "img/amoled.57387475.jpg";